"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentsPageGQLService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const documentsPage_1 = require("../documentsPage");
class DocumentsPageGQLService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.createDocument = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(documentsPage_1.documentCreate, variables, options, requestOptions);
      return response.data.documents.create;
    });
    this.editDocument = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(documentsPage_1.documentEdit, variables, options, requestOptions);
      return response.data.documents.edit;
    });
    this.getDocumentsList = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(documentsPage_1.documentsList, variables, options, requestOptions);
      return response.data.documents;
    });
    this.getCategories = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(documentsPage_1.categories, variables, options, requestOptions);
      return response.data.documents.categories;
    });
    this.getFilters = (variables = {}, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(documentsPage_1.filtersList, variables, options, requestOptions);
      return response.data.documents.filtersList;
    });
    this.getDocumentInfo = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(documentsPage_1.singleDocument, variables, options, requestOptions);
      return response.data.documents.single;
    });
    this.downloadSelectedDocuments = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(documentsPage_1.downloadDocuments, variables, options, requestOptions);
      return response.data.documents.download;
    });
    this.deleteDocuments = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(documentsPage_1.deleteDocuments, variables, options, requestOptions);
      return response.data.documents.delete;
    });
    this.setFavorite = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(documentsPage_1.documentSetFavorite, variables, options, requestOptions);
      return response.data.documents.setFavorite;
    });
    this.getDocumentPageHistory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(documentsPage_1.documentsPageHistory, variables, options, requestOptions);
      return response.data.documents.history;
    });
    this.editCategory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(documentsPage_1.editCategory, variables, options, requestOptions);
      return response.data.documents.editCategory;
    });
  }
}
exports.DocumentsPageGQLService = DocumentsPageGQLService;
const documentsPageGQLService = new DocumentsPageGQLService();
exports.default = documentsPageGQLService;